module.exports = __webpack_public_path__ + "img/header_banner.629db715.jpg";